module.exports = __webpack_public_path__ + "img/copy4.6d341465.svg";